import { ButtonHTMLAttributes, MouseEventHandler } from 'react';
import IconProps from '../../atoms/Icon/Icon.types';

const IconButtonVariety = {
  Square: 'square',
  SmallIcon: 'smallIcon',
  Arrow: 'arrow',
  Rounded: 'rounded',
  SmallSquare: 'smallSquare',
} as const;

type IconButtonVarietyTypes = typeof IconButtonVariety[keyof typeof IconButtonVariety];

export default interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
  variety: IconButtonVarietyTypes;
  text?: string;
  icon?: IconProps;
  dataCy?: string;
  trackingLabel?: string;
  label?: string;
  iconDirection?: IconDirection;
  blackBoldText?: boolean;
}

export { IconButtonVariety, IconButtonVarietyTypes };

export enum IconDirection {
  LEFT = 1,
  RIGHT,
}
